<template>
	<div class="alerts">
		<div v-for="alert in alerts" :key="alert.id">
			<app-alert :type="alert.type" :message="alert.message" @close="onClose(alert.id)"/>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		alerts() {
			return this.$notifications.getAlerts()
		},
	},
	methods: {
		onClose(id) {
			this.$notifications.removeAlert(id)
		},
	},
}
</script>

<style scoped>
	.alerts {
		position: fixed;
    right: 10px;
    bottom: 40px;
    width: 320px;
    z-index: 999;
	}

	@media screen and (max-width: 599px) {
		.alerts {
			bottom: auto;
			top: 60px;
			right: auto;
		}
	}
</style>
